import { ReactElement } from 'react';
import styles from './AddressFieldAlertContent.module.scss';

interface iProps {
  title: string;
}

const AddressFieldAlertContent = ({ title }: iProps): ReactElement => (
  <>
    <p className={styles.msgWarning}>
      Your
      {` ${title.toLowerCase()} `}
      could not be automatically matched
    </p>
    <p>
      Please manually confirm your
      {` ${title.toLowerCase()} `}
      details below
    </p>
  </>
);

export default AddressFieldAlertContent;
